import React from 'react';
import { FormattedMessage } from 'react-intl';

export default props => (
  <p>
    <FormattedMessage
      id="commitForm.signinOption.text"
      defaultMessage="Have a Key Travel account?"
    />
    {' '}
    <button type="button" className="btn-link" onClick={props.onSigninClick}>
      <FormattedMessage
        id="commitForm.signinOption.button"
        defaultMessage="Sign in"
      />
    </button>
  </p>
);



// WEBPACK FOOTER //
// ./src/desktop/components/commit-form/signin-option.js